import { render, staticRenderFns } from "./Bankings.vue?vue&type=template&id=49d4b8a8&"
import script from "./Bankings.vue?vue&type=script&lang=js&"
export * from "./Bankings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports